import { Modal } from 'AppReact';
import { ContentWrapper, OuterWrapper } from './../common/wrappers'
import stateManager from '../../state';


export default Modal({
  outerWrapper: OuterWrapper,
  contentWrapper: ContentWrapper,
  isOpen: ({ termsAccepted }) => termsAccepted,
  close: () => stateManager.setTermsAccepted(false)
})
